import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import * as _ from "lodash";
import { useLazyQuery } from "@apollo/client";


// components
import PaginationHelper from "../../components/PaginationHelper";
import CustomButton from "../../components/CustomButton";
import { COLOR_APP, removeFields, SHOP_SETTING_KEY, USER_KEY } from "../../const";
import { numberFormat, calculateVat } from "../../helper";
import { errorSwal, successSwal } from "../../helper/sweetalert";
import Product from "./product/Product";
import Carts from "./Carts";
import { QRCode } from "react-qrcode-logo";

// redux
import { useDispatch, useSelector } from "react-redux";
import { addCategorytList } from "../../redux/reducers/categoryReducer";
// import { addExchangeRate } from "../../redux/reducers/exchangeRateReducer";
import { addPrinter } from "../../redux/reducers/printerReducer";

// apollo-client
import {
  ELASTICSEARCH_PRODUCT,
  GET_EXCHANGE_RATE,
  GET_PRODUCTS,
  HIDE_PRODUCT_OUT_OF_STOCK,
} from "../../apollo/product/query";
import { GENERATE_CODE, GET_GEN_CODE_ORDER_GROUP } from "../../apollo/ordergroup/query";
import { GET_CATEGORYS } from "../../apollo/category/query";
import { GET_PRINTERS } from "../../apollo/printer/Query";
import { GET_BRANDS } from "../../apollo/brand/Query";
import { GET_PROMOTIONS, GET_SHOP } from "../../apollo/shop/Query";
import { GET_PRODUCT_VARIANTS } from "../../apollo/productVariant/query";

// react-icons
import { GridView, ViewList } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

// react bootrap
import InputGroup from "react-bootstrap/InputGroup";
import { Button, Offcanvas, ButtonGroup, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import debounce from "debounce";
import useWindowDimensions from "../../helper/windowDimensions";
import { MdCardTravel, MdStar, MdClear, MdVisibilityOff, MdStyle } from "react-icons/md";
import { FaCartPlus } from "react-icons/fa";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { parse } from "graphql";
import { GET_SETTING_BY_SHOP } from "../../apollo/setting_apollo/query";

function Sale() {
  const Location = useLocation();
  const saleEditdata = Location;

  const dispatch = useDispatch();
  const { categoryList } = useSelector((state) => state.category);
  const { printers } = useSelector((state) => state.printer);

  const { height, width } = useWindowDimensions()
  const { t, i18n } = useTranslation();
  const shopSetting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY)) || {};
  const commissionEnable = shopSetting?.commissionEnable ?? false;
  const [languageName, setLanguageName] = useState();
  const [showSalePageQr, setShowSalePageQr] = useState(false);
  const [copiedSalePageLink, setCopiedSalePageLink] = useState(false);


  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const salePageUrl = `https://salepage.packxi.shop/shop/${shopId ?? ""}`;

  const handleCopySalePageLink = async () => {
    try {
      if (!shopId) {
        return errorSwal("ບໍ່ພົບຮ້ານ ກະລຸນາກວດສອບຂໍ້ມູນຮ້ານ");
      }
      await navigator.clipboard.writeText(salePageUrl);
      setCopiedSalePageLink(true);
      setTimeout(() => {
        setCopiedSalePageLink(false);
      }, 2000);
      successSwal("ຄັດລອກລິ້ງເຊລເພຈສຳເລັດ!");
    } catch (err) {
      errorSwal("ຄັດລອກລິ້ງບໍ່ສຳເລັດ");
    }
  };

  const handleGenerateQr = () => {
    if (!shopId) {
      return errorSwal("ບໍ່ພົບຮ້ານ ກະລຸນາກວດສອບຂໍ້ມູນຮ້ານ");
    }
    setShowSalePageQr(true);
  };

  const handleDownloadQr = () => {
    try {
      const canvas = document.querySelector("#salepage-qr");
      if (!canvas) {
        return errorSwal("ບໍ່ພົບ QR ສຳລັບດາວໂຫລດ");
      }
      const url = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = url;
      a.download = `shop-${shopId}-qr.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      errorSwal("ດາວໂຫລດ QR ບໍ່ສຳເລັດ");
    }
  };

  const [products, setProducts] = useState([]);
  const [originProducts, setOriginProducts] = useState([]);
  const [totalProduct, setTotalProduct] = useState(0);
  const [categoriesData, setCategoriesData] = useState();
  const [promotionData, setPromotionData] = useState();


  const [cartDatas, setCartDatas] = useState([
    {
      id: 1,
      label: "Bill 1",
      data: {
        orders: [],
        orderGroup: {
          amount: 0,
          totalPrice: 0,
          receivedMoney: 0,
          change: 0,
          sumPrice: 0,
          sumPriceBaht: 0,
          sumPriceUsd: 0,
          currency: "LAK",
          shop: shopId,
          payment: "CASH",
          discount: 0,
          discountType: false,
          shippingCost: 0,
          costTitle: "ຄ່າຂົນສົ່ງ",
          commissionPlatforms: "POS",
          commissionTotal: 0
        },
      },
    },
  ]);
  const [serviceOther, setServiceOther] = useState([]);
  //   shippingCost: null,
  //   discount: null,
  //   notes: '',
  // }]);

  const [activeCart, setActiveCart] = useState("Bill 1");
  const [newExchangeRate, setNewExchangeRate] = useState();
  const [isTableList, setIsTableList] = useState(true);
  const [brand, setBrand] = useState();


  const [selectedPrice, setSelectedPrice] = useState(0);
  const [selectedPayCurrency, setSelectedPayCurrency] = useState("LAK");
  const [gencodeordergroup, setGenCodeOrderGroup] = useState();
  const containerRef = useRef(null);
  const [filterData, setFilterData] = useState([]);
  const [shopDataNew, setShopDataNew] = useState()

  const [elasticData, setElasTicData] = useState("");
  const [elasticSearchName, setElasticSearchName] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isMobileCart, setIsMobileCart] = useState(false)
  const [settingObject, setSettingObject] = useState({});

  const [filters, setFilter] = useState({
    // star: false
    hideZero: shopId === "63edde5526fb6c3c8465ba68" ? false : true,
    hasVariant: false
  });

  const displayProducts = useMemo(() => (products), [products]);


  // ເມື່ອເລືອກສິນຄ້າເຂົ້າກະຕ່າແລ້ວ ໃຫ້ scroll ເລື່ອນລົງ auto ຕາມລາຍການສິນຄ້າ
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };

  // ==========> useLazyQuery And useMutation <==========

  const [getProductDatas, { data: productDatas, loading: productLoading }] =
    useLazyQuery(GET_PRODUCTS, { fetchPolicy: "cache-and-network" });

  const [getHideProductsOutOfStock, { data: hideProductData, loading: hideProductLoading }] =
    useLazyQuery(HIDE_PRODUCT_OUT_OF_STOCK, { fetchPolicy: "cache-and-network" });

  const [getProductVariants, { data: productVariantsData, loading: productVariantsLoading }] =
    useLazyQuery(GET_PRODUCT_VARIANTS, { fetchPolicy: "cache-and-network" });

  const [
    loadElasticSearchData,
    { data: elasticSearchData, loading: elasticSearchLoading },
  ] = useLazyQuery(ELASTICSEARCH_PRODUCT, { fetchPolicy: "cache-and-network" });

  const [getPrinterDatas, { data: printerDatas }] = useLazyQuery(GET_PRINTERS, {
    fetchPolicy: "cache-and-network",
  });

  const [getExchangeRate, { data: exchangeRateData, loading: loadingExchangeRate }] = useLazyQuery(
    GET_EXCHANGE_RATE,
    { fetchPolicy: "cache-and-network" }
  );

  const [LoadCategory, { data: GetCategoryData }] = useLazyQuery(
    GET_CATEGORYS,
    { fetchPolicy: "cache-and-network" }
  );

  const [LoadBrand, { data: GetBrandData }] = useLazyQuery(GET_BRANDS, {
    fetchPolicy: "cache-and-network",
  });

  const [LoadGenCode, { data: GetGenCodeData }] = useLazyQuery(
    GET_GEN_CODE_ORDER_GROUP,
    { fetchPolicy: "network-only" }
  );
  
  const [generateCode, { loading: loadingGenerateCode }] = useLazyQuery(
    GENERATE_CODE,
    { fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data?.generateCode?.status) {
          setGenCodeOrderGroup(data?.generateCode?.tag);
        } else {
          console.log("Generate code error: ", data?.generateCode?.msg);
        }
      },
      onError: (error) => {
        console.log("Generate code error: ", error);
      },
    }
  );

  //LazyQuery create function 7/30/2024  
  const [loadShop, { data: shopData, loading: loadingShop }] = useLazyQuery(GET_SHOP, { fetchPolicy: "cache-and-network", });
  const [getPromotionData, { loading: loadingPromotion, data: promotionDatasLoad }] = useLazyQuery(GET_PROMOTIONS, {
    fetchPolicy: "network-only"
  });
  const [loadSettingShop, { data: settingShop }] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-and-network" });


  // ==========> useEffect <==========

  const optionPrice = [
    { id: 0, name: t("option_price_01") },
    { id: 1, name: t("option_price_02") },
    { id: 2, name: t("option_price_03") },
  ];


  useEffect(() => {
    try {
      scrollToBottom();

      // _loadGenCode();
      _generateCode();

      loadSettingShop({
        variables: {
          where: { shop: shopId },
        },
      });

      //TODO: Get all exchange rate
      if (!exchangeRateData) {
        getExchangeRate({
          variables: {
            where: {
              shop: shopId,
            },
          },
        });
      }
      // TODO: Get all category

      if (categoryList.length === 0) {
        LoadCategory({
          variables: {
            limit: 100,
            where: {
              shop: shopId,
              isDeleted: false,
            },
          },
        });
      }

      // TODO: Get all printer
      if (printers.length === 0) {
        getPrinterDatas({
          variables: {
            where: {
              shop: shopId,
              isDeleted: false,
            },
          },
        });
      }
      _fetchsetShop()
      filterBrand();
    } catch (error) {
      console.error("An error occurred:", error);
    }

    // get promotions
    fetchPromotionDatas(shopId)
  }, [shopId]);
  
  
  useEffect(() => {
    if (promotionDatasLoad) {
      const { data } = promotionDatasLoad?.getPromotions || {};
      const promotion = data?.[0] || null;
      setPromotionData(promotion);
      setCartDatas(prevCart => [
        {
          ...prevCart[0], // Preserve other properties
          data: {
            ...prevCart[0].data,
            orderGroup: {
              ...prevCart[0].data.orderGroup,
              discount: promotion?.discount || 0,
              discountType: promotion?.discountType || false,
            },
          },
        },
      ]);
    }
  }, [promotionDatasLoad]);
  
  useEffect(() => {

    if (GetCategoryData?.categories?.data) {
      // Create a new array with sorted data
      const result = [...GetCategoryData.categories.data].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      dispatch(addCategorytList(result));
    }

    if (exchangeRateData?.exchangeRate) {
      setNewExchangeRate(exchangeRateData.exchangeRate)
      localStorage.setItem("EXCHANGE_RATE", JSON.stringify(exchangeRateData.exchangeRate));
      // dispatch(addExchangeRate(exchangeRateData.exchangeRate));
    }

    if (printerDatas?.printers?.data) {
      dispatch(addPrinter(printerDatas?.printers?.data));
    }

    const source = filters?.hasVariant 
      ? (productVariantsData?.productVariants ? {
          total: productVariantsData.productVariants.total,
          data: productVariantsData.productVariants.data.map((variant) => ({
            ...variant,
            name: `${variant.product?.name || ""} ${variant.attributeValues?.map((val) => val.value).join(" ") || ""}`,
            productName: variant.product?.name,
            image: variant.image ? [variant.image] : [],
            priceOptions: [{ price: variant.price, contain: 1 }],
            hasVariant: false,
            // Map other necessary fields if missing
            category: variant.product?.category,
            brandName: variant.product?.brandName,
            stock: variant.product?._id || variant.product?.id,
            productVariant: variant.id,
          }))
        } : undefined)
      : (filters?.hideZero ? hideProductData?.hideProductsOutOfStock : productDatas?.products);

    if (source) {
      const { data, total } = source;
      const newDataArray = [...data];
      setTotalProduct(total);
      setProducts(newDataArray);
      setOriginProducts(newDataArray);
    }

    if (settingShop) {
      setSettingObject(settingShop?.settingByShopId)
    }
  }, [
    GetCategoryData?.categories?.data,
    exchangeRateData?.exchangeRate,
    productDatas?.products,
    hideProductData?.hideProductsOutOfStock,
    productVariantsData?.productVariants,
    printerDatas?.printers?.data,
    settingShop,
    filters?.hideZero,
    filters?.hasVariant
  ]);

  useEffect(() => {

    if (GetGenCodeData) {
      const number = GetGenCodeData?.orderGroups?.total + 1;
      let _genBarCode = number.toString().padStart(4, "0");
      setGenCodeOrderGroup(_genBarCode);
    }
  }, [GetGenCodeData]);

  useEffect(() => {

    if (GetBrandData?.brands?.data?.length > 0) {
      const dataCopy = [...GetBrandData.brands.data]; // Create a shallow copy of the array
      const result = dataCopy.sort((a, b) => a?.name?.localeCompare(b?.name));
      setBrand(result);
    }
  }, [GetBrandData]);

  useEffect(() => {
    updateOrderGroup();
  }, [JSON.stringify(cartDatas), selectedPayCurrency]);

  useEffect(() => {

    if (filters?.category) {
      filterBrand();
    }

    _filter();
  }, [
    filters?.name,
    filters?.category,
    filters?.brand,
    filters?.star,
    filters?.hideZero,
    filters?.hasVariant,
    selectedPrice,
    _skip,
    // searchStar,
  ]);
  useEffect(() => {
    if (elasticSearchName) {
      elasticSearchProduct();
    }
  }, [elasticData, elasticSearchName]);

  useEffect(() => {
    if (!_.isEmpty(elasticSearchData)) {
      // Get the data from the API response
      const searchData = elasticSearchData?.getProductElastisSearch?.data || [];
      
      // Remove duplicates based on product name
      const uniqueMap = new Map();
      searchData.forEach(item => {
        if (item?.name && !uniqueMap.has(item.name)) {
          uniqueMap.set(item.name, item);
        }
      });
      
      // Convert back to array
      const uniqueData = Array.from(uniqueMap.values());
      
      // Update state with unique items
      setFilterData(uniqueData);
    }
  }, [elasticSearchData]);

  // TODO: Update order group body
  useEffect(() => {

    if (saleEditdata.state?.isEdited) {
      const _offerPriceGroupData = saleEditdata.state?.state;

      const cartItems =
        _offerPriceGroupData?.orders ?? _offerPriceGroupData?.offerprices;
      const updatedProduct = _.cloneDeep(productDatas?.products?.data); // Make a deep copy of the original array

      const _newOrders = cartItems?.map((order) => {
        const stockId = order?.stock?.id ?? order?.stock ?? order?.product;
        // Find the index of the object
        const _pIndex = _.findIndex(updatedProduct, {
          id: stockId,
        });

        if (_pIndex >= 0) {
          const availableAmount = parseInt(updatedProduct[_pIndex]?.amount);
          const orderAmount = parseInt(order?.amount);


          updatedProduct[_pIndex] = {
            ...updatedProduct[_pIndex],
            amount: saleEditdata.state?.isFromSale
              ? availableAmount
              : Math.max(0, availableAmount - orderAmount), // ป้องกันจำนวนติดลบ
          };

          setOriginProducts(updatedProduct);
        }
        // clean data children __typename
        const children = order?.children;
        let cleanDataChildren;
        if (children) {
          const fieldsToRemove = ["__typename"];
          cleanDataChildren = removeFields(children, fieldsToRemove);
        }
        return {
          id: order?.id,
          amount: order?.amount,
          amountChild: order?.amountChild,
          volume: order?.volume,
          volumeChild: order?.volumeChild,
          price: order?.price,
          totalPrice: order?.totalPrice,
          total: order?.totalPrice,
          shop: _offerPriceGroupData?.shop?.id,
          product: stockId,
          productName: order?.productName,
          survival: order?.stock?.survivalId?.survivalNumber ?? order?.survival ?? null,
          currency: order?.currency ? order?.currency : "LAK",
          size: order?.size ?? order?.stock?.size ?? null,
          dimension: {
            height: order?.dimension?.height ?? order?.stock?.dimension?.height ?? null,
            length: order?.dimension?.length ?? order?.stock?.dimension?.length ?? null,
            weight: order?.dimension?.weight ?? order?.stock?.dimension?.weight ?? null,
            width: order?.dimension?.width ?? order?.stock?.dimension?.width ?? null
          },
          children: cleanDataChildren,
          options: removeFields(order?.options, ["__typename"]),
          commissionPlatform: order?.commissionPlatform || "POS",
          commissionType: order?.commissionType,
          commissionValue: order?.commissionValue || 0
        };
      }).filter(order => order !== null); // กรองสินค้าที่จำนวนไม่พอออก

      const _newCartData = {
        id: 1,
        label: "Bill 1",
        data: {
          orders: _newOrders,
          orderGroup: {
            amount: _offerPriceGroupData?.amount,
            volume: _offerPriceGroupData?.volume,
            totalPrice: _offerPriceGroupData?.totalPrice,
            sumPrice: _offerPriceGroupData?.sumPrice,
            receivedMoney: _offerPriceGroupData?.receivedMoney,
            change: 0,
            sumPriceBaht: _offerPriceGroupData?.sumPriceBaht,
            sumPriceUsd: _offerPriceGroupData?.sumPriceUsd,
            currency: "LAK",
            shop: _offerPriceGroupData?.shop?.id,
            payment: "CASH",
            discount: _offerPriceGroupData?.discount ?? promotionData?.discount ?? 0,
            discountType: _offerPriceGroupData?.discountType ?? promotionData?.discountType ?? false,
            commissionPlatforms: _offerPriceGroupData?.commissionPlatforms || _offerPriceGroupData?.commissionPlatform || "POS",
            commissionTotal: _offerPriceGroupData?.commissionTotal || 0
          },
        },
      }


      setCartDatas([_newCartData]);
    }
  }, [saleEditdata.state?.isEdited]);

  useEffect(() => {
    if (shopData) {
      setShopDataNew(shopData)

    }
  }, [shopData])


  const _fetchsetShop = () => {
    const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    loadShop({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };


  // ==========> fuctions <==========

  const filterBrand = () => {
    let _where = {
      shop: shopId,
      isDeleted: false,
    };
    if (filters?.category) {
      _where = { ..._where, category: filters?.category };
    }
    // TODO: Get all brand
    LoadBrand({
      variables: {
        // limit: 50,
        where: _where,
      },
    });
  };

  const _filter = async () => {
    try {
      let _where = { shop: shopId, isDeleted: false };

      if (!_.isEmpty(categoriesData) && categoriesData !== "ALL") {
        _where = {
          ..._where,
          category: categoriesData?.id,
          categoryName: categoriesData?.name,
        };
      }

      // if (filters?.category)
      if (filters?.brand) _where = { ..._where, brand: filters?.brand, brandName: filters?.brandName };
      if (filters?.name) _where = { ..._where, name: filters?.name };
      if (filters?.star) _where = { ..._where, star: true };
      // if (filters?.hasVariant) _where = { ..._where, hasVariant: true }; // Removed as per requirement to use variant query
      else _where = { ..._where };

      const variables = {
        skip: (_skip - 1) * _limit,
        limit: _limit,
        orderBy: "createdAt_DESC",
        where: _where,
      };
      if (filters?.hasVariant) {
        getProductVariants({ variables: { ...variables, skip: 0, limit: 1000 } });
      } else if (filters?.hideZero) {
        getHideProductsOutOfStock({ variables });
      } else {
        getProductDatas({ variables });
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // Store the current abort controller reference
  const abortControllerRef = useRef(null);

  const elasticSearchProduct = async () => {
    try {
      // If there's no search text, don't perform a search
      // if (_.isEmpty(elasticData)) {
      //   setFilterData([]);
      //   return;
      // }

      // Cancel any ongoing requests
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create a new abort controller for this request
      const controller = new AbortController();
      abortControllerRef.current = controller;
      const signal = controller.signal;

      // Build the search query
      let _where = { 
        shop: shopId, 
        isDeleted: false,
        name: elasticData.trim() // Trim whitespace from search term
      };
      
      // Add category filter if applicable
      if (!_.isEmpty(categoriesData) && categoriesData !== "ALL") {
        _where = {
          ..._where,
          category: categoriesData?.id,
          categoryName: categoriesData?.name,
        };
      }

      // Add brand filter if applicable
      if (filters?.brand) {
        _where = { 
          ..._where, 
          brand: filters?.brand, 
          brandName: filters?.brandName 
        };
      }

      // Execute the search query
      await loadElasticSearchData({
        variables: {
          limit: 100, // Increased limit for more comprehensive results
          orderBy: "name_ASC",
          where: _where,
        },
        context: { fetchOptions: { signal } },
      });

      // Don't abort immediately - let the component use the results
      // The controller will be aborted when a new search starts
    } catch (error) {
      // Only log errors that aren't from aborting requests
      if (error.name !== 'AbortError') {
        console.error("Search error:", error);
      }
    }
  };

  const _loadGenCode = async () => {
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop
      ?.id;
    await LoadGenCode({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  const _generateCode = async () => {
    if (loadingGenerateCode) return;
    const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    await generateCode({
      variables: {
        where: {
          shop: shopId,
          type: "POS"
        },
      },
    });
  };

  // Fetch Promotion data based on shop ID
  const fetchPromotionDatas = async (shopId) => {
    if (loadingPromotion) return; // Prevent re-triggering if already loading

    try {
      await getPromotionData({
        variables: {
          where: {
            shop: shopId,
            isDeleted: false,
            status: "ACTIVED"
          }
        }
      });
    } catch (err) {
      console.log("Load Promotion error: ", err);
    }
  }

  // Push to an array
  const addOrder = ({ product, productPrice }) => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);

    if (!selectedCart) return;

    const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    // TODO: Check product amount
    // if (product?.amount <= 0) return;

    let amount = 1;
    const isPromo = product?.isPromo || false;
    const priceValue =
      isPromo 
        ? (product?.promoPrice || 0)
        : productPrice > 0
          ? productPrice
          : product?.priceOptions?.length > 0
            ? product?.priceOptions[parseInt(selectedPrice)]?.price
            : product?.price;
    const totalPrice = priceValue * amount;
    // TODO: Check currency and set total price

    // TODO: Set new order
    const commissionPlatforms = removeFields(product?.commissionPlatforms || [], ["__typename"]);
    const commissionChannel = (selectedCart?.data?.orderGroup?.commissionPlatforms || "POS").toUpperCase();
    const commissionMatch = commissionPlatforms.find(
      (platform) => String(platform?.platform || "").toUpperCase() === commissionChannel,
    );
    const _newOrder = {
      amount,
      totalAmount: product?.amount ?? product?.originAmount,
      originPrice: product?.originPrice,
      price:
        priceValue,
      priceOptions: product?.priceOptions,
      totalPrice,
      total: totalPrice,
      shop: shopId,
      product: product?.id,
      productVariant: product?.productVariant ?? null,
      stock: product?.stock ?? product?.id,
      productName: product?.name,
      survival: product?.survivalId?.survivalNumber ?? null,
      brand: product?.brand?.name,
      category: product?.category?.name,
      unit: product?.unitId?.name ?? product?.unit,
      currency: product?.currency ? product?.currency : "LAK",
      commissionPlatforms,
      commissionPlatform: commissionMatch?.platform || commissionChannel,
      commissionType: commissionMatch?.commissionType,
      commissionValue: commissionMatch?.commissionValue || 0,
      size: product?.size ?? null,
      dimension: {
        height: product?.dimension?.height ?? null,
        length: product?.dimension?.length ?? null,
        weight: product?.dimension?.weight ?? null,
        width: product?.dimension?.width ?? null
      }
    };

    // TODO: Set new cart datas
    const _newCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: { orders: [...orders, _newOrder], orderGroup },
        };
      }
      return cart;
    });

    // TODO: Set cartDatas state into cart datas
    if (!_.isEmpty(_newCartDatas)) {
      setCartDatas(_newCartDatas);
    }

    // TODO: Update product quantity
    const updatedOriginProduct = [...originProducts]; // Make a deep copy of the original Product
    const _originProductIndex = _.findIndex(updatedOriginProduct, {
      id: product?.id,
    }); // Find the index of the object
    if (_originProductIndex >= 0) {
      updatedOriginProduct[_originProductIndex] = {
        ...updatedOriginProduct[_originProductIndex],
        amount:
          parseInt(updatedOriginProduct[_originProductIndex]?.amount) -
          parseInt(amount),
      };
      setOriginProducts(updatedOriginProduct);
    }
    scrollToBottom();
    return;
  };

  // Update object within an array
  const updateOrder = ({ product, productId, isAdded, changeValue }) => {
    const _originProductIndex = _.findIndex(originProducts, { id: productId });

    // if (changeValue < 0) return;
    // TODO: Set new orders
    const _newOrders = (cart) =>
      cart?.data?.orders?.map((order) => {
        let amount = order?.amount;

        // console.log("add amount 2---->")

        if (order.product === productId) {
          // console.log("add amount 2.1---->")

          let totalPrice = order?.totalPrice ?? 0;
          let totalPriceBaht = order?.totalPriceBaht ?? 0;
          let totalPriceUsd = order?.totalPriceUsd ?? 0;

          // TODO: Check order amount and product amount
          const updatedOriginProduct = [...originProducts]; // Make a deep copy of

          if (changeValue > 0 || !Number.isFinite(changeValue)) {
            // console.log("add amount 3---->")

            amount = !Number.isFinite(changeValue) ? 0 : changeValue;

            // console.log("changeValue 3---->",changeValue)
            // console.log("amount 3---->",amount)

            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) +
                  parseInt(
                    order?.amount -
                    (!Number.isFinite(changeValue) ? 0 : changeValue)
                  ),
              };
            }
          } else if (isAdded) {
            // console.log("minus amount---->")
            amount++;
            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) + 1,
              };
            }
          } else if (!isAdded) {
            // console.log("add amount---->")
            amount--;
            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) - 1,
              };
            }
          }

          // update product and orgin product
          if (_originProductIndex >= 0) {
            setOriginProducts(updatedOriginProduct);
          }

          //ກວດຈຳນວນສັ່ງຊື້ ມີ ຫຼື ບໍ່
          //ຖ້າບໍ່ມີ ໃຫ້ລາຄາເປັນສູນ
          //ຖ້າມີໃຫ້ ເອົາຈຳນວນ ຄູນ ໃຫ້ລາຄາ
          // TODO: Children sum price
          const sumPriceChildren = order?.children ?
            order.children.reduce((sum, c) => sum + parseInt(c?.totalPrice), 0)
            : 0;

          // TODO: Option
          const optionPrice = order?.options ?
            order.options.reduce((sum, p) => sum + parseInt(p?.price || 0, 10), 0)
            : 0;
          const sumOptionPrice = parseInt(optionPrice || 0, 10) * parseInt(amount || 0, 10);

          const baseTotal = (amount * order?.price) + sumPriceChildren + sumOptionPrice;
          totalPrice = baseTotal;

          return {
            ...order,
            ...{ amount, totalPrice, totalPriceBaht, totalPriceUsd, total: amount * order?.price },
          };
        }
        return order;
      });

    // TODO: Set update cart datas
    let _updateCartDatas = cartDatas?.map((cart) => {
      if (cart?.label === activeCart) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: _newOrders(cart),
          },
        };
      }
      return cart;
    });
    // console.log("======", { _updateCartDatas });
    if (!_.isEmpty(_updateCartDatas)) {

      setCartDatas(_updateCartDatas);
    }
  };

  const updateOrderIndex = ({ product, productId, indexCart, indexOrder, isAdded, changeValue }) => {
    // Get the product ID if it's not provided but we have indexCart and indexOrder
    if (!productId && indexCart !== undefined && indexOrder !== undefined) {
      const targetCart = cartDatas[indexCart];
      if (targetCart?.data?.orders && targetCart.data.orders[indexOrder]) {
        productId = targetCart.data.orders[indexOrder].product;
      }
    }

    const _originProductIndex = _.findIndex(originProducts, { id: productId });

    // if (changeValue < 0) return;
    // TODO: Set new orders
    const _newOrders = (cart, cartIndex) =>
      cart?.data?.orders?.map((order, orderIndex) => {
        let amount = order?.amount;

        // If we're using indices and they match, or we're using product ID
        const shouldUpdateOrder = 
          (indexCart !== undefined && indexOrder !== undefined && 
            cartIndex === indexCart && orderIndex === indexOrder) &&
          (productId && order.product === productId);

        // console.log("shouldUpdateOrder", shouldUpdateOrder);

        if (shouldUpdateOrder) {
          let totalPrice = order?.totalPrice ?? 0;
          let totalPriceBaht = order?.totalPriceBaht ?? 0;
          let totalPriceUsd = order?.totalPriceUsd ?? 0;

          // TODO: Check order amount and product amount
          const updatedOriginProduct = [...originProducts]; // Make a deep copy

          if (changeValue > 0 || !Number.isFinite(changeValue)) {
            amount = !Number.isFinite(changeValue) ? 0 : changeValue;

            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) +
                  parseInt(
                    order?.amount -
                    (!Number.isFinite(changeValue) ? 0 : changeValue)
                  ),
              };
            }
          } else if (isAdded) {
            amount++;
            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) + 1,
              };
            }
          } else if (!isAdded) {
            amount--;
            if (_originProductIndex >= 0) {
              updatedOriginProduct[_originProductIndex] = {
                ...updatedOriginProduct[_originProductIndex],
                amount:
                  parseInt(updatedOriginProduct[_originProductIndex]?.amount) - 1,
              };
            }
          }

          // update product and origin product
          if (_originProductIndex >= 0) {
            setOriginProducts(updatedOriginProduct);
          }

          //ກວດຈຳນວນສັ່ງຊື້ ມີ ຫຼື ບໍ່
          //ຖ້າບໍ່ມີ ໃຫ້ລາຄາເປັນສູນ
          //ຖ້າມີໃຫ້ ເອົາຈຳນວນ ຄູນ ໃຫ້ລາຄາ
          // TODO: Children sum price
          const sumPriceChildren = order?.children ?
            order.children.reduce((sum, c) => sum + parseInt(c?.totalPrice), 0)
            : 0;

          // TODO: Option
          const optionPrice = order?.options ?
            order.options.reduce((sum, p) => sum + parseInt(p?.price || 0, 10), 0)
            : 0;
          const sumOptionPrice = parseInt(optionPrice || 0, 10) * parseInt(amount || 0, 10);

          const baseTotal = (amount * order?.price) + sumPriceChildren + sumOptionPrice;
          totalPrice = baseTotal;

          return {
            ...order,
            ...{ amount, totalPrice, totalPriceBaht, totalPriceUsd, total: amount * order?.price },
          };
        }
        return order;
      });

    // TODO: Set update cart datas
    let _updateCartDatas = cartDatas?.map((cart, cartIndex) => {
      // If we're using indices, update only the specific cart
      // Otherwise use the activeCart as before
      if ((indexCart !== undefined && cartIndex === indexCart) || 
          (indexCart === undefined && cart?.label === activeCart)) {
        const { orders, orderGroup } = cart?.data;
        return {
          ...cart,
          data: {
            orderGroup,
            orders: _newOrders(cart, cartIndex),
          },
        };
      }
      return cart;
    });

    if (!_.isEmpty(_updateCartDatas)) {
      setCartDatas(_updateCartDatas);
    }
  };

  const resolveCommissionMatch = (order, channel) => {
    const normalizedChannel = String(channel || "").toUpperCase();
    if (
      order?.commissionPlatform &&
      String(order.commissionPlatform).toUpperCase() === normalizedChannel
    ) {
      const hasCommissionData =
        order?.commissionType !== undefined &&
        order?.commissionType !== null &&
        order?.commissionValue !== undefined &&
        order?.commissionValue !== null;
      if (hasCommissionData) {
        return {
          platform: order?.commissionPlatform,
          commissionType: order?.commissionType,
          commissionValue: order?.commissionValue,
        };
      }
    }

    if (Array.isArray(order?.commissionPlatforms) && order.commissionPlatforms.length > 0) {
      const match = order.commissionPlatforms.find(
        (platform) =>
          String(platform?.platform || platform || "").toUpperCase() === normalizedChannel,
      );
      if (match) return match;
    }

    const productId = order?.product || order?.stock;
    const sourceProduct = (originProducts || []).find(
      (product) => product?.id === productId,
    );
    const platforms = sourceProduct?.commissionPlatforms || [];
    if (!Array.isArray(platforms)) return null;
    return (
      platforms.find(
        (platform) =>
          String(platform?.platform || "").toUpperCase() === normalizedChannel,
      ) || null
    );
  };

  // TODO: Update order group
  const updateOrderGroup = async () => {
    const selectedCart = cartDatas?.find((cart) => cart.label === activeCart);
    if (!selectedCart) return;

    const { orders, orderGroup } = selectedCart?.data;

    let totalPrice = 0;
    let sumPriceBaht = 0;
    let sumPriceUsd = 0;
    let amount = 0;
    let volume = 0;
    let sumPrice = 0;
    const activeOther = Array.isArray(serviceOther)
      ? serviceOther.find((c) => c?.activeCart === activeCart)
      : serviceOther;
    const shippingCost = parseFloat(activeOther?.shippingCost || 0);
    const exchangeRateBaht = newExchangeRate?.baht || 1;
    const exchangeRateUsd = newExchangeRate?.usd || 1;
    const commissionChannel = (orderGroup?.commissionPlatforms || "POS").toUpperCase();
    let commissionTotal = 0;

    // Sum amount and price and calculate total price in kip
    orders?.forEach((order) => {
      amount += order?.amount || 0;
      let price = 0;
      // TODO: Children
      if (order?.children?.length > 0) {
        const sumPriceChildren = (order?.children || []) ?
          order.children.reduce((sum, c) => {
            if (c?.saleTag === "VOLUME") {
              return sum + (parseInt(c?.totalPrice || 0))
            } else {
              return sum + (parseInt(c?.price) * parseInt(c?.amount))
            }
          }, 0)
          : 0;
        price = (order.price * order.amount) + sumPriceChildren;
        amount += order?.amountChild || 0;
        volume += order?.volumeChild || 0;
        // TODO: Option
      } else if (order?.options?.length > 0) {
        const optionPrice = (order?.options || []) ?
          order.options.reduce((sum, p) => sum + parseInt(p?.price || 0, 10), 0)
          : 0;
        const sumOptionPrice = parseInt(optionPrice || 0, 10) * parseInt(order?.amount || 0, 10);
        price = (order.price * order.amount) + sumOptionPrice;
      } else {
        price = (order.price * order.amount);
      }

      if (commissionEnable) {
        const match = resolveCommissionMatch(order, commissionChannel);
        if (match?.commissionValue) {
          const type = String(match?.commissionType || "").toUpperCase();
          let lineCommission = 0;
          if (type === "PERCENT" || type === "PERCENTAGE") {
            lineCommission = (price * Number(match?.commissionValue || 0)) / 100;
          } else {
            lineCommission = (Number(match?.commissionValue || 0) || 0) * (Number(order?.amount || 0) || 0);
          }
          switch (order?.currency) {
            case "BAHT":
            case "ບາດ":
              commissionTotal += lineCommission * exchangeRateBaht;
              break;
            case "USD":
            case "ໂດລາ":
              commissionTotal += lineCommission * exchangeRateUsd;
              break;
            default:
              commissionTotal += lineCommission;
              break;
          }
        }
      }

      switch (order?.currency) {
        case "LAK":
        case "ກີບ":
          totalPrice += price;
          sumPrice += price;
          break;

        case "BAHT":
        case "ບາດ":
          sumPriceBaht += price;
          sumPrice += price * exchangeRateBaht;
          break;

        case "USD":
        case "ໂດລາ":
          sumPriceUsd += price;
          sumPrice += price * exchangeRateUsd;
          break;

        default:
          // Handle other currencies or fallback if needed
          break;
      }
    });

    if (!_.isEmpty(activeOther?.shippingCost)) {
      sumPrice = sumPrice + shippingCost;
    }

    const basePercentDiscount = parseFloat(orderGroup?.discount) || 0;
    const manualDiscountVal = parseFloat(orderGroup?.discountManual) || 0;
    let deduction = 0;

    if (sumPrice > 0) {
      if (basePercentDiscount > 0) {
        deduction += (sumPrice * basePercentDiscount) / 100;
      }

      if (manualDiscountVal > 0) {
        if (orderGroup?.discountType === false) {
          deduction += (sumPrice * manualDiscountVal) / 100;
        } else {
          deduction += manualDiscountVal;
        }
      }
    }

    if (deduction > 0) {
      const maxCap = parseFloat(activeOther?.maxDiscountAmount || 0);
      if (maxCap > 0) {
        deduction = Math.min(deduction, maxCap);
      }
      orderGroup.discountAmountApplied = deduction;
      sumPrice = sumPrice - deduction;
    }

    // Convert sumPrice based on selected currency
    switch (selectedPayCurrency) {
      case "BAHT":
      case "ບາດ":
        sumPrice = sumPrice / exchangeRateBaht;
        commissionTotal = commissionTotal / exchangeRateBaht;
        break;

      case "USD":
      case "ໂດລາ":
        sumPrice = sumPrice / exchangeRateUsd;
        commissionTotal = commissionTotal / exchangeRateUsd;
        break;

      default:
        // If no currency conversion needed, keep the sumPrice as it is
        break;
    }



    let finalVatResult = null;
    if (settingObject?.taxes?.taxStatus) {
      finalVatResult = calculateVat(sumPrice, settingObject.taxes);
      sumPrice = finalVatResult.sumPrice;
    }

    const _updatedOrderGroup = {
      ...orderGroup,
      amount,
      volume,
      totalPrice,
      sumPriceBaht,
      sumPriceUsd,
      sumPrice,
      discount: orderGroup?.discount || 0,
      discountType: orderGroup?.discountType ?? false,
      discountAmountApplied: orderGroup?.discountAmountApplied || 0,
      receivedMoney: orderGroup?.receivedMoney || 0,
      change: (parseFloat(orderGroup?.receivedMoney || 0) - sumPrice) || 0,
      commissionPlatforms: orderGroup?.commissionPlatforms || "POS",
      commissionTotal,
      ...(finalVatResult && {
        taxes: {
          taxStatus: true,
          tax: settingObject.taxes.tax,
          taxType: settingObject.taxes.taxType,
          isVatIncluded: finalVatResult.isVatIncluded,
          priceBeforeTax: finalVatResult.priceBeforeTax,
          taxAmount: finalVatResult.taxAmount,
        }
      })
    };


    // Update the cart data with the new values
    setCartDatas((prevCarts) =>
      prevCarts.map((cart) => {
        if (cart?.label === activeCart) {
          return {
            ...cart,
            data: { orders, orderGroup: _updatedOrderGroup },
          };
        }
        return cart;
      })
    );
  };


  // Clear order from cart
  const onClearOrder = (order, oIndex, cIndex) => {
    const {splitAmountOrder} = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
    let prevState = [];
    if (splitAmountOrder || shopData?.shop?.id === "678db8f1942eb6002c1f40cd") {
      prevState = cartDatas.map((cart, index) => {
        if (index === cIndex) {
          return {
            ...cart,
            data: {
              orders: cart?.data?.orders.filter((_order, orderIndex) => orderIndex !== oIndex),
              orderGroup: cart?.data?.orderGroup,
            },
          };
        }
        return cart;
      });
    } else {
      prevState = cartDatas.map((cart) => {
        return {
          ...cart,
          data: {
            orders: cart?.data?.orders.filter(
              (_order) =>
                _order.product !== order?.product || cart?.label !== activeCart
            ),
            orderGroup: cart?.data?.orderGroup,
          },
        };
      });
    }
    if (!_.isEmpty(prevState)) {
      setCartDatas(prevState);
    }

    // TODO: Update product uantity
    const _originProductIndex = _.findIndex(originProducts, {
      id: order?.product,
    });
    const updateOriginProduct = [...originProducts];

    updateOriginProduct[_originProductIndex] = {
      ...updateOriginProduct[_originProductIndex],
      amount: originProducts[_originProductIndex].amount + order?.amount,
    };
    setOriginProducts(updateOriginProduct);
    return;
  };

  const handleKeyNameProduct = (e) => {
    if (e.key === "Enter") {

      e.preventDefault();
      let _newValue = e?.target?.value;
      setFilter({
        ...filters,
        name: _newValue,
      });
      console.log("_newValue", _newValue);

      setElasTicData(_newValue);
      setFilterData([])

    }
  };

  const _onChange = (e) => {
    let _value = e?.target?.value;
    // Set Filter name
    setFilter({
      ...filters,
      name: _value,
    });
    // Always update the input value immediately for better UX
    // setElasTicData(_value);
    // setElasticSearchName(true);
    // // console.log("_value", _value);
    // if (_.isEmpty(_value)) {
    //   setFilterData([])
    // }
  }

  // Reduce debounce time to make it more responsive
  const debouncedOnChange = useCallback(debounce(_onChange, 100), []);

  const parentDivRef = useRef(null);

  useEffect(() => {

    // Event listener for clicks outside the parent div
    const handleClickOutside = (event) => {
      if (
        parentDivRef.current &&
        !parentDivRef.current.contains(event.target)
      ) {
        setElasTicData();
        // setFilterData()
      }
    };

    // Attach the event listener to the document body
    document.body.addEventListener("click", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    setLanguageName(language);
  }, [])


  const handleChangeLanguage = async (lgn) => {
    i18n.changeLanguage(lgn);
    setLanguageName(lgn)
  };

  return (
    <>
      <Modal centered show={showSalePageQr} onHide={() => { setShowSalePageQr(false); setCopiedSalePageLink(false); }}>
        <Modal.Header closeButton>
          <Modal.Title>QR ຮ້ານເຊລເພຈ</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "2em" }}>
          <QRCode id="salepage-qr" value={salePageUrl} size={width > 700 ? 220 : 180} />
          <div style={{ marginTop: 16, fontSize: 12, textAlign: "center", wordBreak: "break-all" }}>
            {salePageUrl}
          </div>
          <div
            style={{ marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, cursor: "pointer" }}
            onClick={handleCopySalePageLink}
          >
            {copiedSalePageLink ? (
              <IoCheckmarkDoneSharp style={{ fontSize: 20, color: COLOR_APP }} />
            ) : (
              <ContentCopyIcon style={{ fontSize: 18 }} />
            )}
            <span>ຄັດລອກ</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleDownloadQr}>{t("download", { defaultValue: "ດາວໂຫລດ" })}</Button>
        </Modal.Footer>
      </Modal>
      <div className="Sale-main">
        {/* product list Select */}
        <div style={{ width: "100%" }}>
          {/* navbar */}
          <div
            style={{
              height: "60px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
            }}
          >
            <InputGroup className="mr-2">
              <InputGroup.Text
                style={{
                  backgroundColor: "#FFFFFF",
                  // border: 'none'
                }}
              >
                <SearchIcon sx={{ color: "#6B7280" }} />
              </InputGroup.Text>
              <Form.Control
                placeholder={t("search_product_name")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                onKeyDown={(e) => handleKeyNameProduct(e)}
                onChange={_onChange} //{debouncedOnChange}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => {
                  // Delay hiding the dropdown to allow for clicks on dropdown items
                  setTimeout(() => setIsSearchFocused(false), 200);
                }}
                style={{
                  borderLeft: "none",
                  // border: 'none'
                }}
                // value={elasticData}
                value={filters?.name}
              />
            </InputGroup>
            {!_.isEmpty(filterData) &&
              <>
                {(elasticData?.length > 0 || isSearchFocused) && (
                  <div
                    ref={parentDivRef}
                    style={{
                      position: "absolute",
                      zIndex: 999,
                      left: "1.5em",
                      top: "3.5em",
                      background: "#ffffff",
                      width: "80%",
                      borderRadius: 8,
                      maxHeight: "400px",
                      overflowY: "auto",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    }}
                  >
                    {filterData.map((data, index) => (
                      <div 
                        key={index}
                        onClick={() => {
                          setFilter({
                            ...filters,
                            name: data?.name,
                          });
                          setElasticSearchName(false);
                          setElasTicData(data?.name);
                        }}
                        style={{
                          padding: "8px 16px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                          backgroundColor: "white",
                        }}
                        className="search-item"
                      >
                        {data?.name}
                      </div>
                    ))}
                  </div>
                )}
              </>
            }

            <Form.Select
              className="mr-2"
              style={{
                height: "40px",
                backgroundColor: "#fff",
                color: "#6B7280",
                cursor: "pointer",
                margin: "0px 3px",
                width: width > 700 ? "100%" : 105
              }}
              value={filters?.category}
              onChange={(e) => {
                setFilter({
                  ...filters,
                  category: e?.target?.value,
                });

                const getId = e?.target?.value;
                const selectedCategory = categoryList.find(
                  (data) => data.id === getId
                );
                if (selectedCategory) {
                  const categoryData = {
                    id: selectedCategory.id,
                    name: selectedCategory.name,
                  };
                  setCategoriesData(categoryData);
                } else {
                  setCategoriesData("All");
                }
              }}
            >
              <option value="">{t("category_name_tb")}</option>
              {categoryList?.map((categorys, cIndex) => (
                <option key={cIndex} value={categorys?.id}>
                  {categorys?.name}
                </option>
              ))}
            </Form.Select>

            <Form.Select
              className="mr-2"
              style={{
                height: "40px",
                width: width > 700 ? "100%" : 105,
                backgroundColor: "#fff",
                color: "#6B7280",
                cursor: "pointer",
                margin: "0px 3px",
              }}
              value={filters?.brand}
              onChange={(e) => {
                const selectedBrand = brand?.find(b => b.id === e.target.value);
                setFilter({
                  ...filters,
                  brand: e?.target?.value,
                  brandName: selectedBrand?.name || ''
                });

              }}
            >
              <option value="">{t("brand_name_tb")}</option>
              {brand?.map((brands, index) => (
                <option key={index} value={brands?.id}>
                  {brands?.name}
                </option>
              ))}
            </Form.Select>
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: 5 }}>
            <CustomButton
              width={width > 700 ? 140 : 80}
              borderRadius={8}
              background={filters?.star ? COLOR_APP : "white"}
              color={filters?.star ? "white" : "#6B7280"}
              border={filters?.star ? "" : " 1px solid #D1D5DB"}
              margin={"0px 0px 10px 25px"}
              height={40}
              onClick={() => {
                setFilter({
                  ...filters,
                  star: !filters?.star,
                });

              }}
              title={width > 700 ? t("goods_product_name") : ""}
              icon={width < 700 ? <MdStar /> : ""}
            />
            <CustomButton
              width={80}
              borderRadius={8}
              background={filters?.hideZero ? "white" :COLOR_APP }
              color={filters?.hideZero ? "#6B7280" : "white"}
              border={filters?.hideZero ? "" : " 1px solid #D1D5DB"}
              margin={"0px 0px 10px 5px"}
              height={40}
              onClick={() => {
                setFilter({
                  ...filters,
                  hideZero: !filters?.hideZero,
                });

              }}
              title={""}
              icon={<MdVisibilityOff />}
            />
            {shopId === "6979abcbcd92870013f38787" && (
              <CustomButton
                width={width > 700 ? 170 : 80}
                borderRadius={8}
                background={filters?.hasVariant ? COLOR_APP : "white"}
                color={filters?.hasVariant ? "white" : "#6B7280"}
                border={filters?.hasVariant ? "" : " 1px solid #D1D5DB"}
                margin={"0px 0px 10px 5px"}
                height={40}
                onClick={() => {
                  setFilter({
                    ...filters,
                    hasVariant: !filters?.hasVariant,
                  });
                }}
                title={width > 700 ? t("variant_product_name", { defaultValue: "ສິນຄ້າທີ່ມີຫຼາຍຄ່າ" }) : ""}
                icon={width < 700 ? <MdStyle /> : ""}
              />
            )}
            {width < 700 && (
              <CustomButton
                width={60}
                borderRadius={8}
                background="#6B7280"
                color="white"
                border="none"
                margin={"0px 0px 10px 5px"}
                height={40}
                onClick={handleGenerateQr}
                title={""}
                icon={<QrCode2Icon style={{ fontSize: 20 }} />}
              />
            )}
            <Form.Select
              style={{
                backgroundColor: "#fff",
                color: "#6B7280",
                cursor: "pointer",
                margin: "0px 3px",
                width: 150,
                height: 40,
              }}
              onChange={(e) => {
                setSelectedPrice(e.target.value);

              }}
              value={selectedPrice}
            >
              {optionPrice?.map(({ id, name }) => (
                <option key={id} value={id.toString()}>
                  {name}
                </option>
              ))}
            </Form.Select>

            {width > 700 ? <Button
              onClick={() => setIsTableList(!isTableList)}
              style={{
                backgroundColor: "#6B7280",
                border: "none",
                height: 40,
              }}
            >
              {!isTableList ? (
                <ViewList style={{ color: "#fff" }} />
              ) : (
                <GridView style={{ color: "#fff" }} />
              )}
            </Button>
              : <div
                style={{
                  border: "none",
                  height: 40,
                  marginLeft: width > 400 ? '2em' : 5,
                  padding: 5,
                  position: 'relative',
                  cursor: 'pointer'
                }}
                onClick={() => setIsMobileCart(true)}
              >
                <FaCartPlus style={{ fontSize: 28 }} />

                {cartDatas[0]?.data?.orderGroup?.amount > 0 && <span
                  style={{
                    position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 10, top: -7,
                    right: -10, width: 20, borderRadius: '40em', height: 20, background: 'red', color: 'white'
                  }}>{cartDatas[0]?.data?.orderGroup?.amount ?? 0}</span>}
              </div>}

            <CustomButton
              width={width > 700 ? 120 : 90}
              borderRadius={8}
              background="#DC2626"
              color="white"
              border="none"
              margin={"0px 0px 10px 5px"}
              height={40}
              onClick={() => {
                setFilter({
                  ...filters,
                  star: false,
                  brand: '',
                  brandName: '',
                  category: '',
                  name: '',
                  hideZero: false,
                  hasVariant: false
                });
                // Reset other filter states
                setCategoriesData("All");
                setElasTicData('');
                setSelectedPrice(0); // Reset option price to default
              }}
              title={width > 700 ? t("clear_filter") || "Clear Filter" : ""}
              icon={width < 700 ? <MdClear /> : <MdClear style={{ marginRight: 5 }} />}
            />
          </div>

          {/* Product */}

          <Product
            _skip={_skip}
            _limit={_limit}
            products={products}
            activeCart={activeCart}
            cartDatas={cartDatas}
            updateOrder={updateOrder}//TODO....
            addOrder={addOrder}
            isTableList={isTableList}
            setCartDatas={setCartDatas}
            selectedPrice={selectedPrice}
            originProducts={originProducts}
            optionPrice={optionPrice}
            productLoading={filters?.hasVariant ? productVariantsLoading : (filters?.hideZero ? hideProductLoading : productLoading)}
            productDatas={useMemo(() => (
              filters?.hasVariant ? (productVariantsData?.productVariants ? { products: productVariantsData?.productVariants } : undefined) :
              (filters?.hideZero ? (hideProductData?.hideProductsOutOfStock ? { products: hideProductData?.hideProductsOutOfStock } : undefined) : productDatas)
            ), [filters?.hideZero, filters?.hasVariant, hideProductData, productVariantsData, productDatas])}
            shopData={shopDataNew}
          />


          {/* update 8/12/2024 */}
          <div
            style={{
              display: "flex",
              flexDirection: width > 700 ? "row" : "column",
              justifyContent: "space-around",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ marginTop: ".8em" }}>
              {Pagination_helper(totalProduct, "", ``)}
            </div>

            {totalProduct > 0 && (
              <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                {t("exchange_rate_title")} :  ฿{(loadingExchangeRate && !exchangeRateData) ? "..." : numberFormat(newExchangeRate?.baht)}; &nbsp;  $
                {(loadingExchangeRate && !exchangeRateData) ? "..." : numberFormat(newExchangeRate?.usd)}
              </div>
            )}
          </div>
        </div>

        {/* Cart sale */}
        {width > 700 && <Carts
          products={products}
          setProducts={setProducts}
          cartDatas={cartDatas}
          setCartDatas={setCartDatas}
          activeCart={activeCart}
          setActiveCart={setActiveCart}
          // updateOrder={updateOrder}
          updateOrder={updateOrderIndex}
          onClearOrder={onClearOrder}
          fetchProductData={_filter}
          printer={printers}
          originProducts={originProducts}
          setOriginProducts={setOriginProducts}
          selectedPayCurrency={selectedPayCurrency}
          setSelectedPayCurrency={setSelectedPayCurrency}
          gencodeordergroup={gencodeordergroup}
          // _loadGenCode={_loadGenCode}
          _loadGenCode={_generateCode}
          saleEditdata={saleEditdata}
          containerRef={containerRef}
          productLoading={productLoading}
          addOrder={addOrder}
          shopData={shopDataNew}
          setIsMobileCart={setIsMobileCart}
          serviceOther={serviceOther}
          setServiceOther={setServiceOther}
          settingObject={settingObject}
          promotionData={promotionData}
        />}
      </div >

      <Offcanvas show={isMobileCart} onHide={() => setIsMobileCart(false)} placement="bottom" style={{ height: 640 }}>
        <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #fefefe' }}>
          {/* <Offcanvas.Title>Cart</Offcanvas.Title> */}
          <ButtonGroup aria-label="Basic example">
            <Button variant={languageName === "lao" ? "secondary" : "light"} onClick={() => handleChangeLanguage("lao")}>ພາສາລາວ</Button>
            <Button variant={languageName === "en" ? "secondary" : "light"} onClick={() => handleChangeLanguage("en")}>English</Button>
            <Button variant={languageName === "chi" ? "secondary" : "light"} onClick={() => handleChangeLanguage("chi")}>晉語</Button>
          </ButtonGroup>
        </Offcanvas.Header>
        <Offcanvas.Body >
          <Carts
            products={products}
            setProducts={setProducts}
            cartDatas={cartDatas}
            setCartDatas={setCartDatas}
            activeCart={activeCart}
            setActiveCart={setActiveCart}
            // updateOrder={updateOrder}
            updateOrder={updateOrderIndex}
            onClearOrder={onClearOrder}
            fetchProductData={_filter}
            printer={printers}
            originProducts={originProducts}
            setOriginProducts={setOriginProducts}
            selectedPayCurrency={selectedPayCurrency}
            setSelectedPayCurrency={setSelectedPayCurrency}
            gencodeordergroup={gencodeordergroup}
            // _loadGenCode={_loadGenCode}
            _loadGenCode={_generateCode}
            saleEditdata={saleEditdata}
            containerRef={containerRef}
            productLoading={productLoading}
            addOrder={addOrder}
            shopData={shopDataNew}
            setIsMobileCart={setIsMobileCart}
            serviceOther={serviceOther}
            setServiceOther={setServiceOther}
            promotionData={promotionData}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Sale;
